import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
/* LIBRARIES */
import * as React from 'react';
import { wrapDisplayName } from '@cian/react-utils';
import classNames from 'classnames';
import { isEmpty } from 'ramda';

/* MODULES */
import { getCustomClasses, getStylesClasses, getInlineStyles } from './helpers';

/* STYLES */
import * as stylesModule from './styles.css';
/* TYPES */

export var createIcon = function createIcon(IconComponent, config) {
  var _class;
  var displayName = wrapDisplayName(IconComponent, 'Icon');
  return _class = /*#__PURE__*/function (_React$Component) {
    _inherits(Icon, _React$Component);
    var _super = _createSuper(Icon);
    function Icon() {
      _classCallCheck(this, Icon);
      return _super.apply(this, arguments);
    }
    _createClass(Icon, [{
      key: "render",
      value: function render() {
        var _classNames;
        var props = this.props;
        var _props$dataMark = props.dataMark,
          dataMark = _props$dataMark === void 0 ? displayName : _props$dataMark,
          __classNames = props.__classNames,
          __attributes = props.__attributes,
          custom = props.custom;
        return /*#__PURE__*/React.createElement("div", _extends({
          "data-mark": dataMark,
          className: classNames(stylesModule['container'], config && config.containerClass, (_classNames = {}, _defineProperty(_classNames, getCustomClasses(custom), !isEmpty(custom)), _defineProperty(_classNames, getStylesClasses(props, config), !isEmpty(props)), _classNames), __classNames),
          style: getInlineStyles(props)
        }, __attributes), /*#__PURE__*/React.createElement("div", {
          className: stylesModule['icon']
        }, /*#__PURE__*/React.createElement(IconComponent, null)));
      }
    }]);
    return Icon;
  }(React.Component), _defineProperty(_class, "displayName", displayName), _defineProperty(_class, "SVG", IconComponent), _class;
};